module.exports = __webpack_public_path__ + "img/detail-expand-icon.c08bb6be.svg";